"use client"

type RelatedProductDetailsProps = {
    uri?: string
    name: string
    price?: string
    priceBeforeDiscount: string
    showAsOnSale: boolean
}

export default function RelatedProductDetails({
    uri,
    name,
    price,
    priceBeforeDiscount,
    showAsOnSale
}: RelatedProductDetailsProps) {
    return (
        <div className="col-span-12 flex flex-col gap-8 md:col-span-12">
            <div className="flex flex-col gap-4">
                <p className="Trim_Mono_POC_Text_12_130_6_500_uppercase">{name}</p>

                <p className="flex w-full min-w-0 flex-wrap items-baseline gap-x-8 text-col-text-secondary Trim_Mono_POC_Text_12_130_-3_400_uppercase">
                    {showAsOnSale && (
                        <span className="shrink-0 whitespace-nowrap line-through">
                            {priceBeforeDiscount}
                        </span>
                    )}
                    <span className="shrink-0 whitespace-nowrap">{price}</span>
                </p>
            </div>
        </div>
    )
}
